import { useEffect } from "react";
import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import { useSelector } from "react-redux";

const ZoomableImageModal = ({ handleModalToggle }) => {
  const { activeUrl, zoomModelVisibility, title } = useSelector(
    (state) => state.carromm
  );
  useEffect(() => {
    if (zoomModelVisibility && activeUrl) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [zoomModelVisibility]);

  return (
    <>
      {zoomModelVisibility && activeUrl ? (
        <div
          aria-hidden="true"
          className={`${
            zoomModelVisibility ? "flex" : "hidden"
          } overflow-y-auto overflow-x-hidden fixed bg-[#0000005e] h-full top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full`}
        >
          <div className="relative p-4 w-full max-w-[850px] max-h-full">
            <div className={` bg-white shadow p-4`}>
              <div className="relative">
                <button
                  type="button"
                  className={` absolute top-4 right-4 text-sm w-8 h-8 inline-flex rounded justify-center items-center z-10 bg-white`}
                  onClick={handleModalToggle}
                  aria-label="Close"
                >
                  <svg
                    width={16}
                    height={16}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={handleModalToggle}
                  >
                    <path
                      d="M22 2L2 22M2 2L22 22"
                      stroke={"black"}
                      strokeWidth={3}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <InnerImageZoom
                  src={activeUrl || ""}
                  className={`$ h-auto object-cover max-lg:w-full w-full max-md:h-[280px] !block`}
                  alt={`Vehicle ${activeUrl + 1}`}
                  onError={(e) => {
                    e.target.src = "";
                  }}
                  zoomType="click"
                  zoomPreload={false}
                  onClick={handleModalToggle}
                />
              </div>
              {title && <p className="background-title model-heading">{title}</p>}
            </div>

          </div>
         
        </div>
      ) : null}
    </>
  );
};
export default ZoomableImageModal;
